import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { useHapticFeedback } from '@blade/ui-kit'
import { CurrencyIcon } from '@root/entities/currency/ui'

import { LimitOrderItemActions } from './limit-order-item-actions'
import { LimitOrderItemFooter } from './limit-order-item-footer'
import { LimitOrderItemPair } from './limit-order-item-pair'

import type { LimitOrderModel } from '../../../atoms'

type Props = {
  order: LimitOrderModel
  onClick?: (order: LimitOrderModel) => void
  onEdit?: (order: LimitOrderModel) => void
  onCancel?: (order: LimitOrderModel) => void
}

export const LimitOrderItem: React.FC<Props> = ({
  order,
  onEdit,
  onCancel,
  onClick,
}) => {
  const haptics = useHapticFeedback()
  const [status] = useAtom(order.status)

  const handleClick = () => {
    if (onClick) {
      haptics.impactOccurred('light')
      onClick(order)
    }
  }

  return (
    <LimitOrderItemRoot onClick={handleClick} $active={status === 'active'}>
      <Body>
        <CurrencyIcon currency={order.pair.quote} size={36} withNetwork />
        <LimitOrderItemPair order={order} />
        <LimitOrderItemActions
          onEdit={onEdit}
          onClose={onCancel}
          order={order}
        />
      </Body>
      <LimitOrderItemFooter order={order} />
    </LimitOrderItemRoot>
  )
}

export const LimitOrderItemRoot = styled.div<{ $active?: boolean }>`
  background: var(--background-3);
  border: 1px solid var(--backgroundA-2);

  display: grid;
  align-items: center;
  position: relative;

  border-radius: 12px;
`

const Body = styled.div`
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  overflow: hidden;
  position: relative;
  border-bottom: 1px solid var(--backgroundA-2);

  height: 56px;
  padding-inline: 10px 0;
  gap: 8px;
`
